
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyers",
      function () {
        return require("private-next-pages/buyers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyers"])
      });
    }
  